import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/staff', data)
    .then(response => {
      return response.data
    })
}
function update(data, id) {
  return axios.patch(`/staff/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/staff', { params: params })
      .then(response => {
        return response.data
      })
  },
  fetchStats(params) {
    return axios.get('/staff/stats', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  destroy(id) {
    return axios.delete(`/staff/${id}`)
  }
}
